import Auth from 'works/legacy/lib/auth';

class ColumnsStore {
  KEY_BY_MEMBERSHIP = 'worksColumnsByMembership';

  constructor() {}

  getAll() {
    try {
      const membershipId = Auth.membershipId();
      return membershipId ? this.load()[membershipId] || {} : {};
    } catch (error) {
      return {};
    }
  }

  get(key: string) {
    const filters = this.getAll();
    return filters[key] || undefined;
  }

  set(key: string, columns: string[]) {
    if (!key) return;

    const currentColumns = this.getAll();

    currentColumns[key] = columns;

    const membershipId = Auth.membershipId();
    if (membershipId) this.store(membershipId, currentColumns);
  }

  store(membershipId: string, columns: string[]) {
    const columnsStored = {
      ...this.load(),
      [membershipId]: columns,
    };

    localStorage.setItem(this.KEY_BY_MEMBERSHIP, JSON.stringify(columnsStored));
  }

  load() {
    const raw = localStorage.getItem(this.KEY_BY_MEMBERSHIP);
    return raw ? JSON.parse(raw) : {};
  }
}

export const selectColumnsStore = new ColumnsStore();
